import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


interface IMyPageIconProps extends IConDefaultType {}

function MyPageIcon({ color, className, size = 24, rotate, flip, style }: IMyPageIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        ...style,
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_6856_129092" maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
          <circle cx="12" cy="12" r="10" fill="white" />
        </mask>
        <g mask="url(#mask0_6856_129092)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 26C2.89543 26 2 25.1046 2 24C2 18.8101 6.66294 15 11.8947 15C17.1265 15 21.7895 18.8101 21.7895 24C21.7895 25.1046 20.894 26 19.7895 26H4ZM19.4625 22C18.492 19.1085 15.4711 17 11.8947 17C8.3184 17 5.29747 19.1085 4.32693 22C4.11422 22.6337 4 23.305 4 24H6H17.7895H19.7895C19.7895 23.305 19.6753 22.6337 19.4625 22Z"
            fill={fill}
          />
          <circle cx="12" cy="10.5" r="3.5" stroke={fill} strokeWidth="2" strokeLinejoin="round" />
        </g>
        <circle cx="12" cy="12" r="10" stroke={fill} strokeWidth="2" />
      </svg>
    </i>
  );
}

export default MyPageIcon;
